import { foodSchema, type Food } from './nutrition'

// Reviewed 2026-10-18. Calories apply ONLY to each named temperature/sweetness/bean recipe.
// 450ml is a referenced cup capacity, not a measured liquid yield or a grams conversion.
const luckin = [
  ['latte', '拿铁', '热', 268, '埃塞金烘/默认浓度/不另外加糖/牛奶', ['瑞幸拿铁', '瑞幸的拿铁', '瑞幸热拿铁', '瑞幸咖啡拿铁', 'luckin latte']],
  ['coconut-latte', '生椰拿铁', '冰', 179, '埃塞金烘/默认浓度/不另外加糖', ['瑞幸生椰拿铁', '生椰拿铁']],
  ['iced-coconut-latte', '冰吸生椰拿铁', '冰', 196, '意式拼配/默认浓度/不另外加糖', ['瑞幸冰吸生椰拿铁', '冰吸生椰拿铁']],
  ['jasmine-latte', '茉莉花香拿铁', '冰', 76, '埃塞金烘/默认浓度/不另外加糖/牛奶', ['瑞幸茉莉花香拿铁', '茉莉花香拿铁']],
  ['light-coconut-jasmine-latte', '轻椰茉莉拿铁', '冰', 120, '意式拼配/默认浓度/不另外加糖', ['瑞幸轻椰茉莉拿铁', '轻椰茉莉拿铁']],
  ['velvet-latte', '丝绒拿铁', '热', 376, '埃塞金烘/默认浓度/不另外加糖', ['瑞幸丝绒拿铁', '丝绒拿铁']],
  ['butter-latte', '小黄油拿铁', '冰', 250, '埃塞金烘/默认浓度/不另外加糖', ['瑞幸小黄油拿铁', '小黄油拿铁']],
] as const
function drink(id: string, name: string, temperature: string, kcal: number, specification: string, aliases: readonly string[], sourcePath: string, ml = 450): Food {
  return foodSchema.parse({
    id: `brand:luckin:${id}:2026-10-18`, origin: 'brand', sourceId: `luckin-${id}`, sourceVersion: '2026-10-18',
    name: `瑞幸${name}（大杯·${temperature}·${specification.includes('少甜') ? '少甜' : '不另外加糖'}）`, aliases,
    category: sourcePath.includes('tea') ? '品牌饮品 茶饮 奶茶 轻乳茶 瑞幸 luckin' : '品牌饮品 咖啡 瑞幸 luckin', kcal, unit: '份', basis: 1,
    drinkServing: { ml, label: `大杯 · ${temperature} · ${specification}`, volumeBasis: 'cupCapacity', volumeSource: ml === 450 ? 'reference' : 'brand' },
    brandSourceUrl: `https://www.lkcoffee.com/products/${sourcePath}`,
    description: `2026-10-18核对官网：${kcal}kcal/杯，${temperature}/${specification}。${ml === 450 ? '大杯杯体约450ml，杯量参考饮品资料页；' : '官网16oz杯型约473ml；'}杯容量不等于实际液体量。冷热、奶基底、加糖、加料及杯型改变需另查，不能只按容量推算另一配方。未公布的营养不补0。`,
  })
}
export const BRAND_DRINKS: readonly Food[] = [
  ...luckin.map(([id, name, temperature, kcal, specification, aliases]) => drink(id, name, temperature, kcal, specification, aliases, `lattes/${id}`)),
  drink('salted-caramel-latte', '海盐焦糖拿铁', '冰', 206, '意式拼配/少甜', ['瑞幸海盐焦糖拿铁', '海盐焦糖拿铁'], 'lattes/salted-caramel-latte', 473),
  drink('americano', '标准美式', '冰', 11, '埃塞金烘/默认浓度/不另外加糖/无奶', ['瑞幸美式', '瑞幸标准美式', '瑞幸冰美式'], 'americanos'),
  drink('orange-americano', '橙C美式', '冰', 122, '埃塞金烘/默认浓度/不另外加糖/无气泡', ['瑞幸橙C美式', '橙C美式'], 'americanos'),
  drink('jasmine-milk-tea', '鲜萃轻轻茉莉', '冰', 95, '不另外加糖/不含轻咖', ['瑞幸鲜萃轻轻茉莉', '鲜萃轻轻茉莉', '瑞幸茉莉轻乳茶', '瑞幸奶茶', '瑞幸轻乳茶'], 'light-milk-teas'),
]
